// src/components/core/ProtectedRoute.js
import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import AccessContext from '../../context/AccessContext';
import Loading from './Loading';

const ProtectedRoute = ({ children }) => {
  const { availableRoutes } = useContext(AccessContext);

  const location = useLocation();

  // 1) Data is still loading
  if (availableRoutes === null) {
    return <Loading />;
  }

  // Authorization is based solely on route access entries

  // 5) Check if user can access the current route
  const currentPath = location.pathname.split('/')[1]; // Gets the first part of the path
  
  if (!availableRoutes.includes(currentPath)) {
    return (
      <Navigate
        to="/access-denied"
        replace
        state={{ reason: 'You are not authorized to view this route.' }}
      />
    );
  }

  // If all checks pass, render child
  return children;
};

export default ProtectedRoute;
